import React, { useEffect, useRef, useState } from "react";
import electricalproblem from "../../../../../assets/image/services/electricalproblem.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import corrosssion from "../../../../../assets/image/services/corrosssion.webp";
import electrical4 from "../../../../../assets/image/services/electrical4.webp";
import dimlights from "../../../../../assets/image/services/dimlights.webp";
import engine from "../../../../../assets/image/services/engine.webp";
import Electricservice from "../../../../../assets/image/services/ElectricService.jpg";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import overlay from "../../../../../assets/image/overlay.jpg";
import MyButton from "../../utils/Button/MyButton";

export default function Electrical() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);

  return (
    <>
      {/* Electrical Services*/}

      <div className="text-black max-w-full  md:w-full overflow-x-hidden">
        {/* Image Column (5/12 on large) */}
        <div className="lg:col-span-5 md:col-span-1 relative   w-full  ">
          <img
            className=" lg:h-[30rem] md:h-[25rem]  md:w-[100%] h-[20rem] lg:max-w-[100%] object-cover"
            src={electricalproblem}
            alt="electricalproblem"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/70 to-transparent"></div>
          <h3
            className={`text-white font-bold mb-5 absolute lg:text-[3.5rem] md:text-3xl text-center flex items-center inset-0 justify-center 
              transition-all duration-[2500ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
          >
            VAP Electrical Services
          </h3>
          <div
            className={`w-full flex items-center justify-center absolute  lg:top-[53%]  md:top-[51%] top-[53%]  mx-auto
          transition-all duration-[900ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text=" Electrical Services"
                className="bg-orange-500 text-white  px-4 rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12 on large) */}
        <div className="lg:col-span-5 md:col-span-1  lg:px-[9.65rem] md:px-[6%] mx-2 ">
          <div className="lg:pt-0 md:pt-0 pt-[15px] text-center  ">
            <p className="my-3 lg:block md:block hidden  text-gray-700 lg:font-normal text-xl leading-relaxed">
              Electrical issues in vehicles can be some of the most complex and
              frustrating to diagnose. Unlike mechanical failures, they often
              occur intermittently, making them easy to overlook—until they
              escalate into costly repairs. Modern vehicle electrical systems
              are intricate, and what appears to be a minor issue—such as a
              clicking relay, a drained battery, or an unresponsive
              dashboard—can often indicate a deeper underlying problem.
            </p>
            <p className="lg:mb-6 md:mb-4 lg:font-normal  text-gray-700 text-xl">
              This is where expertise matters. Our skilled professionals don’t
              rely on trial and error; they use advanced diagnostic tools to
              trace faults, test connections, and pinpoint failures with
              precision. By identifying the root cause rather than just treating
              the symptoms, we ensure accurate, long-lasting solutions.
            </p>
            <p className="lg:text-2xl md:text-xl text-[1.3rem]  font-semibold text-black lg:mb-8 md:mb-8 mb-1">
              Get Your Free Battery Test
            </p>
          </div>

          <div
            className={`flex items-center justify-center mt-2 mx-auto lg:ml-[42%] w-full mb-10 
           transition-all duration-[950ms] delay-[2000ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer flex items-center">
                Book Now <FaArrowRight className="ml-2" />
              </button> */}
              <MyButton
                text="Book Now"
                className="transform py-[11px] transition-transform duration-500 hover:scale-105"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]    ">
        <div className="py-[30px] container">
          <h1 className="text-blue-900 font-bold lg:text-5xl md:text-4xl text-center  mb-3 ">
            Signs of Electrical Issues
          </h1>
          <p className="mb-3 lg:font-normal text-[1.35rem] lg:px-[9.5%]  text-center">
            Common electrical issues in vehicles include dim lights,
            unresponsive electronics, and a burning smell—often caused by faulty
            wiring, a weak battery, or malfunctioning alternator problems. A
            non-starting engine, rapid battery drain, or frequent blown fuses
            can also signal deeper hidden electrical faults that need prompt,
            professional attention.
          </p>
          {/* <ul className="text-lg lg:ml-14 ">
            <li className="flex flex-col">
              <span className="font-bold "> Dim or flickering lights :-</span>
              <span>
                {" "}
                Faulty wiring, battery issues, or alternator problems can cause
                inconsistent lighting.
              </span>
            </li>
            <li className="flex flex-col">
              <span className="font-bold">
                Unresponsive or erratic electronics :-
              </span>
              <span>
                {" "}
                A malfunctioning stereo, power windows, or dashboard displays
                may indicate wiring or fuse problems.
              </span>
            </li>
            <li className="flex  flex-col">
              <span className="font-bold">Burning smell :-</span>
              <span>
                {" "}
                Overheated wires or electrical shorts can pose a fire hazard and
                need immediate attention.
              </span>
            </li>
            <li className="flex  flex-col">
              <span className="font-bold"> Engine not starting :-</span>
              <span>
                {" "}
                A failing battery, starter motor, or alternator could be the
                culprit behind a non-starting vehicle.
              </span>
            </li>
            <li className="flex flex-col">
              <span className="font-bold">
                {" "}
                Battery corrosion or rapid drainage :-
              </span>
              <span>
                {" "}
                Corrosion on the terminals or unexplained battery drain can
                point to charging system issues.
              </span>
            </li>
            <li className="flex flex-col">
              <span className="font-bold">
                {" "}
                Blown fuses or warning lights :-
              </span>
              <span>
                {" "}
                Recurring fuse failures or illuminated dashboard warning lights
                indicate deeper electrical malfunctions.
              </span>
            </li>
          </ul> */}
          <div className="flex justtify-center items-center lg:px-[5%]  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] my-[4%] justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={engine}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem] lg:h-[22rem] md:h-[24rem] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Prevent Electrical{" "}
                      <span className="text-[#2772AD]">Failures </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    Avoid costly breakdowns by addressing electrical problems
                    before they escalate. Small issues like faulty wiring, dead
                    batteries, or blown fuses can quietly build up over
                    time—leading to major system failures. Early diagnosis and
                    routine inspections help ensure your vehicle stays
                    road-ready.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] my-[4%] justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Reliable Car{" "}
                      <span className="text-[#2772AD]">Electronics</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    Enjoy seamless performance—fully functioning lights,
                    electronics, and ignition every time you start your car.
                    Electrical issues may start small but can quickly affect
                    critical systems, leaving you stranded or causing further
                    damage without warning.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] w-full   lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={dimlights}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem] w-full lg:h-[22rem] md:h-[24rem] h-[17rem] object-cover"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={electrical4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[24rem] h-[17rem] w-full object-cover "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Reliable Charging{" "}
                      <span className="text-[#2772AD]">System</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    Voltage drops from weak alternators cause flickering lights
                    and poor sensor response—test your charging system
                    regularly. Left unchecked, charging issues can affect
                    ignition, electronics, and battery life, leading to
                    unreliable and unexpected breakdowns.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="lg:w-[53vw] mx-auto flex flex-col justify-between bg-white  p-3 text-center rounded-2xl shadow space-y-6 mt-3 mb-10">
            <div>
              <p className="text-blue-900 font-bold text-2xl md:text-3xl mb-2">
                Expert Electrical System Diagnostics & Repairs
              </p>
              <p className="text-lg md:text-xl mb-3">
                Modern vehicles rely on complex electrical systems. We
                specialize in identifying and fixing problems with starters,
                batteries, wiring, sensors, and more.
              </p>
            </div>

            <div className="space-y-2 text-start">
              {[
                "Starter & Ignition System Repairs",
                "Battery & Charging System Diagnostics",
                "Wiring & Ground Fault Inspections",
                "Module & Sensor Troubleshooting",
                "Lighting & Accessory Repairs",
              ].map((category, idx) => (
                <span
                  key={idx}
                  className="p-2   text-blue-900 font-semibold text-xl rounded-xl cursor-pointer hover:bg-blue-200 transition flex gap-2 items-center"
                >
                  <img src={check} className="h-6 w-6" />
                  {category}
                </span>
              ))}
            </div>
            <div className="lg:pt-2">
              <Link to="/contact-us">
                {/* <button className="w-full flex justify-center items-center px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white text-lg font-semibold rounded-full transition">
                    Get a FREE Estimate today <FaArrowRight className="ml-3" />
                  </button> */}
          {/*  <MyButton
                  text="Get a FREE Estimate today"
                  className="w-full flex justify-center items-center px-3 py-3 bg-blue-600  text-white text-lg font-semibold rounded-full transition"
                />
              </Link>
            </div>
          </div> */}
        </div>
        <div
          className="bg-gray-50 bg-cover bg-center relative text-white "
          style={{ backgroundImage: `url(${overlay})` }}
        >
          <div className="bg-black bg-opacity-50 px-4 py-[25px] flex flex-col items-center justify-center text-center min-h-[300px] md:min-h-[300px]">
            <p className="mb-6 text-white lg:text-3xl md:text-3xl text-2xl font-semibold max-w-4xl">
              Stay ahead of electrical failures. We offer proactive diagnostics
              that prevent issues before they disrupt your ride.
            </p>
            <Link to="/contact-us">
              {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-xl font-bold hover:bg-orange-600 transition ">
              Reserve Your Free Service
            </button> */}
              <MyButton
                text="Reserve Your Free Service"
                className="px-6 py-[12px] transform transition-transform duration-500 hover:scale-105"
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
